// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container matching Dashboard gradient */
.elder-groups-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
    font-family: inherit;
    display: flex;
    flex-direction: column;
}

.center-content {
    justify-content: center;
    align-items: center;
}

.loading-text {
    margin-top: 1.5rem;
    font-size: 1.2rem;
    color: #475569;
    font-weight: 500;
}

/* === HEADER === */
.groups-header {
    margin-bottom: 1.5rem;
}

.elder-back-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: white;
    border: 1px solid #cbd5e1;
    padding: 0.6rem 1rem;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    color: #334155;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.elder-back-btn:hover {
    background: #f1f5f9;
    border-color: #94a3b8;
    color: #1e293b;
}

.page-title {
    margin: 0;
    font-size: 1.5rem;
    color: #1e293b;
    font-weight: 800;
}

/* === MAIN CONTENT === */
.groups-main-content {
    padding: 0 2rem 4rem 2rem;
    max-width: 900px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}

.elder-section {
    margin-bottom: 1rem;
}

.elder-section-title {
    font-size: 1.4rem;
    color: #1e293b;
    font-weight: 700;
    margin-bottom: 1rem;
    padding-left: 0.25rem;
}

.elder-divider {
    height: 1px;
    background: #cbd5e1;
    margin: 2rem 0;
}

/* === LIST STYLES (STRIP CARDS) === */
.elder-list-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.elder-list-card {
    background: white;
    border-radius: 16px;
    padding: 1.25rem 1.5rem;
    border: 1px solid rgba(226, 232, 240, 0.8);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.clickable-card {
    cursor: pointer;
}

.clickable-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    border-color: #bfdbfe;
}

.clickable-card:hover .action-arrow {
    transform: translateX(4px);
    color: #2563eb;
}

/* Inside the strip card */
.list-card-left {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    flex: 1 1;
}

.list-card-info {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.list-card-right {
    flex-shrink: 0;
}

/* Icons */
.icon-wrapper {
    height: 50px;
    width: 50px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.blue-icon {
    background: #eff6ff;
    color: #3b82f6;
}

.green-icon {
    background: #f0fdf4;
    color: #10b981;
}

.action-arrow {
    color: #94a3b8;
    transition: transform 0.2s ease, color 0.2s ease;
}

/* Typography & Stats */
.elder-card-title {
    margin: 0;
    font-size: 1.2rem;
    color: #1e293b;
    font-weight: 700;
}

.elder-stats-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.stat-value {
    font-size: 1rem;
    color: #475569;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.2rem;
}

.stat-divider {
    color: #cbd5e1;
    font-size: 1.2rem;
}

.green-text {
    color: #059669;
}

/* === BUTTONS === */
.elder-btn-primary {
    background: #2563eb;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s;
    white-space: nowrap;
}

.elder-btn-primary:hover:not(:disabled) {
    background: #1d4ed8;
}

.elder-btn-primary:disabled {
    background: #94a3b8;
    cursor: not-allowed;
}

.elder-btn-secondary {
    background: white;
    color: #475569;
    border: 1px solid #cbd5e1;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
}

.elder-btn-secondary:hover {
    background: #f1f5f9;
    color: #1e293b;
    border-color: #94a3b8;
}

.elder-btn-success {
    background: #f0fdf4;
    color: #059669;
    border: 2px solid #10b981;
    padding: 0.65rem 1.25rem;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: default;
    white-space: nowrap;
}

.elder-empty-card {
    background: white;
    border-radius: 16px;
    padding: 2rem;
    text-align: center;
    font-size: 1.1rem;
    color: #64748b;
    border: 2px dashed #cbd5e1;
}

/* === MODAL STYLES === */
.elder-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 1rem;
}

.elder-modal-card {
    background: white;
    border-radius: 20px;
    padding: 2rem;
    max-width: 400px;
    width: 100%;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    text-align: center;
    animation: scaleIn 0.2s ease-out;
}

@keyframes scaleIn {
    from {
        transform: scale(0.95);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

.elder-modal-card h3 {
    margin: 0 0 1rem 0;
    color: #1e293b;
    font-size: 1.4rem;
}

.elder-modal-card p {
    color: #475569;
    font-size: 1.1rem;
    margin-bottom: 2rem;
    line-height: 1.5;
}

.elder-modal-actions {
    display: flex;
    gap: 1rem;
}

.elder-modal-actions button {
    flex: 1 1;
}

/* === RESPONSIVE FOR MOBILE === */
@media (max-width: 768px) {
    .groups-header {
        padding: 1.25rem;
    }

    .groups-main-content {
        padding: 0 1.25rem 3rem 1.25rem;
    }

    .elder-list-card {
        padding: 1rem;
    }

    .icon-wrapper {
        height: 44px;
        width: 44px;
    }

    .elder-card-title {
        font-size: 1.1rem;
    }

    .stat-value {
        font-size: 0.9rem;
    }

    .available-group-card {
        flex-direction: column;
        align-items: flex-start;
        gap: 1.25rem;
    }

    .available-group-card .list-card-left {
        width: 100%;
    }

    .available-group-card .list-card-right {
        width: 100%;
    }

    .elder-btn-primary,
    .elder-btn-success {
        width: 100%;
        justify-content: center;
        padding: 1rem;
    }

    .elder-modal-actions {
        flex-direction: column;
    }
}


/* =========================================
   === CUSTOM DIALOG MODALS UI ===
   ========================================= */

.elder-modal-card {
    background: white;
    border-radius: 20px;
    padding: 2.5rem 2rem;
    max-width: 400px;
    width: 100%;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    animation: scaleIn 0.2s ease-out;
}

.modal-icon-wrapper {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.5rem;
}

.elder-modal-actions {
    display: flex;
    gap: 1rem;
    width: 100%;
}

.elder-modal-actions button {
    flex: 1 1;
}

.full-width {
    width: 100%;
}

/* Modal Colors */
.bg-red-light {
    background: #fef2f2;
}

.text-red {
    color: #dc2626;
}

.bg-green-light {
    background: #ecfdf5;
}

.text-green {
    color: #059669;
}

.bg-blue-light {
    background: #eff6ff;
}

.text-blue {
    color: #2563eb;
}

/* Fill Buttons */
.btn-danger-fill {
    background: #ef4444 !important;
    color: white !important;
}

.btn-danger-fill:hover {
    background: #dc2626 !important;
}

.btn-success-fill {
    background: #10b981 !important;
    color: white !important;
}

.btn-success-fill:hover {
    background: #059669 !important;
}

.btn-blue-fill {
    background: #2563eb !important;
    color: white !important;
}

.btn-blue-fill:hover {
    background: #1d4ed8 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/member/Groups.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,8CAA8C;IAC9C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,6EAA6E;AACjF;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;IAC/C,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA,UAAU;AACV;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gDAAgD;AACpD;;AAEA,uBAAuB;AACvB;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,0BAA0B;AAC9B;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,qFAAqF;IACrF,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI;QACI,sBAAsB;QACtB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA,kCAAkC;AAClC;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,WAAW;QACX,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;;AAGA;;8CAE8C;;AAE9C;IACI,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,qFAAqF;IACrF,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":["/* Container matching Dashboard gradient */\n.elder-groups-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);\n    font-family: inherit;\n    display: flex;\n    flex-direction: column;\n}\n\n.center-content {\n    justify-content: center;\n    align-items: center;\n}\n\n.loading-text {\n    margin-top: 1.5rem;\n    font-size: 1.2rem;\n    color: #475569;\n    font-weight: 500;\n}\n\n/* === HEADER === */\n.groups-header {\n    margin-bottom: 1.5rem;\n}\n\n.elder-back-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: white;\n    border: 1px solid #cbd5e1;\n    padding: 0.6rem 1rem;\n    border-radius: 10px;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #334155;\n    cursor: pointer;\n    transition: all 0.2s;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.elder-back-btn:hover {\n    background: #f1f5f9;\n    border-color: #94a3b8;\n    color: #1e293b;\n}\n\n.page-title {\n    margin: 0;\n    font-size: 1.5rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n/* === MAIN CONTENT === */\n.groups-main-content {\n    padding: 0 2rem 4rem 2rem;\n    max-width: 900px;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.elder-section {\n    margin-bottom: 1rem;\n}\n\n.elder-section-title {\n    font-size: 1.4rem;\n    color: #1e293b;\n    font-weight: 700;\n    margin-bottom: 1rem;\n    padding-left: 0.25rem;\n}\n\n.elder-divider {\n    height: 1px;\n    background: #cbd5e1;\n    margin: 2rem 0;\n}\n\n/* === LIST STYLES (STRIP CARDS) === */\n.elder-list-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.elder-list-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.25rem 1.5rem;\n    border: 1px solid rgba(226, 232, 240, 0.8);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.clickable-card {\n    cursor: pointer;\n}\n\n.clickable-card:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n    border-color: #bfdbfe;\n}\n\n.clickable-card:hover .action-arrow {\n    transform: translateX(4px);\n    color: #2563eb;\n}\n\n/* Inside the strip card */\n.list-card-left {\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n    flex: 1;\n}\n\n.list-card-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n}\n\n.list-card-right {\n    flex-shrink: 0;\n}\n\n/* Icons */\n.icon-wrapper {\n    height: 50px;\n    width: 50px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.blue-icon {\n    background: #eff6ff;\n    color: #3b82f6;\n}\n\n.green-icon {\n    background: #f0fdf4;\n    color: #10b981;\n}\n\n.action-arrow {\n    color: #94a3b8;\n    transition: transform 0.2s ease, color 0.2s ease;\n}\n\n/* Typography & Stats */\n.elder-card-title {\n    margin: 0;\n    font-size: 1.2rem;\n    color: #1e293b;\n    font-weight: 700;\n}\n\n.elder-stats-inline {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}\n\n.stat-value {\n    font-size: 1rem;\n    color: #475569;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 0.2rem;\n}\n\n.stat-divider {\n    color: #cbd5e1;\n    font-size: 1.2rem;\n}\n\n.green-text {\n    color: #059669;\n}\n\n/* === BUTTONS === */\n.elder-btn-primary {\n    background: #2563eb;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: background 0.2s;\n    white-space: nowrap;\n}\n\n.elder-btn-primary:hover:not(:disabled) {\n    background: #1d4ed8;\n}\n\n.elder-btn-primary:disabled {\n    background: #94a3b8;\n    cursor: not-allowed;\n}\n\n.elder-btn-secondary {\n    background: white;\n    color: #475569;\n    border: 1px solid #cbd5e1;\n    padding: 0.75rem 1.5rem;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.elder-btn-secondary:hover {\n    background: #f1f5f9;\n    color: #1e293b;\n    border-color: #94a3b8;\n}\n\n.elder-btn-success {\n    background: #f0fdf4;\n    color: #059669;\n    border: 2px solid #10b981;\n    padding: 0.65rem 1.25rem;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: default;\n    white-space: nowrap;\n}\n\n.elder-empty-card {\n    background: white;\n    border-radius: 16px;\n    padding: 2rem;\n    text-align: center;\n    font-size: 1.1rem;\n    color: #64748b;\n    border: 2px dashed #cbd5e1;\n}\n\n/* === MODAL STYLES === */\n.elder-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(15, 23, 42, 0.6);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 1rem;\n}\n\n.elder-modal-card {\n    background: white;\n    border-radius: 20px;\n    padding: 2rem;\n    max-width: 400px;\n    width: 100%;\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n    text-align: center;\n    animation: scaleIn 0.2s ease-out;\n}\n\n@keyframes scaleIn {\n    from {\n        transform: scale(0.95);\n        opacity: 0;\n    }\n\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n.elder-modal-card h3 {\n    margin: 0 0 1rem 0;\n    color: #1e293b;\n    font-size: 1.4rem;\n}\n\n.elder-modal-card p {\n    color: #475569;\n    font-size: 1.1rem;\n    margin-bottom: 2rem;\n    line-height: 1.5;\n}\n\n.elder-modal-actions {\n    display: flex;\n    gap: 1rem;\n}\n\n.elder-modal-actions button {\n    flex: 1;\n}\n\n/* === RESPONSIVE FOR MOBILE === */\n@media (max-width: 768px) {\n    .groups-header {\n        padding: 1.25rem;\n    }\n\n    .groups-main-content {\n        padding: 0 1.25rem 3rem 1.25rem;\n    }\n\n    .elder-list-card {\n        padding: 1rem;\n    }\n\n    .icon-wrapper {\n        height: 44px;\n        width: 44px;\n    }\n\n    .elder-card-title {\n        font-size: 1.1rem;\n    }\n\n    .stat-value {\n        font-size: 0.9rem;\n    }\n\n    .available-group-card {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 1.25rem;\n    }\n\n    .available-group-card .list-card-left {\n        width: 100%;\n    }\n\n    .available-group-card .list-card-right {\n        width: 100%;\n    }\n\n    .elder-btn-primary,\n    .elder-btn-success {\n        width: 100%;\n        justify-content: center;\n        padding: 1rem;\n    }\n\n    .elder-modal-actions {\n        flex-direction: column;\n    }\n}\n\n\n/* =========================================\n   === CUSTOM DIALOG MODALS UI ===\n   ========================================= */\n\n.elder-modal-card {\n    background: white;\n    border-radius: 20px;\n    padding: 2.5rem 2rem;\n    max-width: 400px;\n    width: 100%;\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    animation: scaleIn 0.2s ease-out;\n}\n\n.modal-icon-wrapper {\n    width: 72px;\n    height: 72px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 0.5rem;\n}\n\n.elder-modal-actions {\n    display: flex;\n    gap: 1rem;\n    width: 100%;\n}\n\n.elder-modal-actions button {\n    flex: 1;\n}\n\n.full-width {\n    width: 100%;\n}\n\n/* Modal Colors */\n.bg-red-light {\n    background: #fef2f2;\n}\n\n.text-red {\n    color: #dc2626;\n}\n\n.bg-green-light {\n    background: #ecfdf5;\n}\n\n.text-green {\n    color: #059669;\n}\n\n.bg-blue-light {\n    background: #eff6ff;\n}\n\n.text-blue {\n    color: #2563eb;\n}\n\n/* Fill Buttons */\n.btn-danger-fill {\n    background: #ef4444 !important;\n    color: white !important;\n}\n\n.btn-danger-fill:hover {\n    background: #dc2626 !important;\n}\n\n.btn-success-fill {\n    background: #10b981 !important;\n    color: white !important;\n}\n\n.btn-success-fill:hover {\n    background: #059669 !important;\n}\n\n.btn-blue-fill {\n    background: #2563eb !important;\n    color: white !important;\n}\n\n.btn-blue-fill:hover {\n    background: #1d4ed8 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
